import { Button, Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';
import { mqDevices } from '~/utils';

const spacingMd = getTheme('spacing.md');
const spacingXl = getTheme('spacing.xl');
const spacingLg = getTheme('spacing.lg');

const themeRadiusCard = getTheme('themeRadius.card');
const borderRadiusMax = getTheme('borderRadius.max');

const backgroundZ3 = getTheme('background.z3');
const backgroundZ4 = getTheme('background.z4');
const textMain = getTheme('text.main');

export const Wrapper = styled.div`
  height: fit-content;
  flex-direction: column;
  align-items: center;
  max-width: ${pxToRem(400)};
  background: ${backgroundZ4};
  border-radius: ${themeRadiusCard}px;
  padding: ${spacingLg}px ${spacingMd}px;

  @media ${mqDevices.inMobileAndTablet} {
    flex: 1;
    flex-direction: row;
    max-width: 100%;
    align-self: center;
    margin-bottom: ${spacingLg}px;
    padding: ${spacingMd}px;
  }
`;

export const Name = styled(Typography).attrs({ variant: 'md' })`
  font-weight: bold;
  margin-top: ${spacingMd}px;
  margin-bottom: ${spacingXl}px;
  text-align: center;
`;

export const Contact = styled(Typography)`
  font-weight: 500;
  opacity: 0.5 !important;
`;

export const ContactCard = styled.div`
  width: 100%;
  flex-direction: column;
  border-radius: ${themeRadiusCard}px;
  padding: 0 ${spacingMd}px;
  background: ${backgroundZ3};
  margin: ${spacingMd}px 0;
  overflow-y: scroll;

  @media ${mqDevices.inMobileAndTablet} {
    height: 100%;
    margin: 0;
    margin-bottom: ${spacingMd}px;
  }
`;

export const ContactItemBox = styled.div`
  align-items: center;
  margin: ${spacingMd}px 0;
`;

export const IconStyled = styled(Icon)`
  font-size: ${pxToRem(20)};
  color: ${textMain};
  opacity: 0.3;
`;

export const LabelBox = styled.div`
  flex-direction: column;
  margin-left: ${spacingMd}px;
`;

export const Label = styled(Typography).attrs({ variant: 'xs' })`
  text-transform: uppercase;
  opacity: 0.5 !important;
`;

export const Value = styled(Typography)`
  opacity: 0.8 !important;
`;

export const ButtonSeeData = styled(Button)`
  width: 100%;
  min-height: ${pxToRem(50)};
  border-radius: ${borderRadiusMax}px;
`;

export const IconPlus = styled(Icon)`
  font-size: ${pxToRem(17)};
  margin-right: ${spacingMd}px;
`;

export const Column = styled.div`
  flex: 1;
  width: 100%;
  flex-direction: column;
  align-items: center;

  @media ${mqDevices.inMobileAndTablet} {
    height: 100%;
    justify-content: center;
  }
`;
